import styled from 'styled-components';
import { Table } from '@thinknet-gmbh/platform-common-ui';

export const StyledTable = styled(Table)`
  .ant-table-thead {
    background: ${({ theme }) => theme.colors.tone.lightGrey};
  }
  .ant-table-thead > tr > th {
    padding: 9px 12px;
  }
  .ant-table-content .ant-table-tbody {
    .ant-table-row td > div {
      padding: 5px 12px;
    }
  }
  .ant-table-footer {
    background: none;
    padding: 0;
    padding-top: 7px;
    .ant-btn {
      padding: 0;
    }
  }
`;
